import { ROUTES } from '@/config/constants';

/**
 * Absolute URL Supabase redirects back to after OAuth / magic-link / email
 * confirmation / password recovery. Always `<current origin>/auth/callback`, so
 * it resolves correctly on localhost AND production with no per-env config — you
 * only have to add each origin's callback URL to Supabase → Authentication →
 * URL Configuration → Redirect URLs.
 *
 * @param next Optional in-app path to land on once the session is established
 *             (defaults to the home/explore page in the callback handler).
 */
export function authCallbackURL(next?: string): string {
  const url = new URL(ROUTES.authCallback, window.location.origin);
  if (next) url.searchParams.set('next', next);
  return url.toString();
}
